const REMEMBERED_EMAIL_KEY = 'fiyatOnayRememberedEmail';
const LEGACY_USER_KEY = 'fiyatOnayUser';
const PORTAL_TOKEN_KEY = 'fiyatOnayToken';
const SELECTED_COMPANY_KEY_PREFIX = 'fiyatOnaySelectedCompany:';

export function getSelectedCompany(userId: string): string | null {
    try {
        const companyId = localStorage.getItem(`${SELECTED_COMPANY_KEY_PREFIX}${userId}`)?.trim();
        return companyId || null;
    } catch {
        return null;
    }
}

export function saveSelectedCompany(userId: string, companyId: string): void {
    try {
        localStorage.setItem(`${SELECTED_COMPANY_KEY_PREFIX}${userId}`, companyId);
    } catch {
        // The in-memory selection remains available until the current session ends.
    }
}

export function clearSelectedCompany(userId: string): void {
    try {
        localStorage.removeItem(`${SELECTED_COMPANY_KEY_PREFIX}${userId}`);
    } catch {
        // The in-memory selection is cleared by the auth context.
    }
}

export function migrateStoredCredentials(): string {
    try {
        const legacyUser = localStorage.getItem(LEGACY_USER_KEY) || sessionStorage.getItem(LEGACY_USER_KEY);
        const rememberedEmail = localStorage.getItem(REMEMBERED_EMAIL_KEY);
        let email = rememberedEmail || '';

        if (!email && legacyUser) {
            try {
                const parsed = JSON.parse(legacyUser);
                if (typeof parsed.email === 'string') email = parsed.email;
            } catch {
                // Invalid legacy data is removed below.
            }
        }

        localStorage.removeItem(LEGACY_USER_KEY);
        sessionStorage.removeItem(LEGACY_USER_KEY);
        localStorage.removeItem(PORTAL_TOKEN_KEY);

        if (email) localStorage.setItem(REMEMBERED_EMAIL_KEY, email);
        else localStorage.removeItem(REMEMBERED_EMAIL_KEY);

        return email;
    } catch {
        return '';
    }
}

export function rememberEmail(email: string, shouldRemember: boolean): void {
    try {
        if (shouldRemember) localStorage.setItem(REMEMBERED_EMAIL_KEY, email);
        else localStorage.removeItem(REMEMBERED_EMAIL_KEY);
    } catch {
        // Remembering an email is optional and must not block sign-in.
    }
}

export function clearPortalToken(): void {
    try {
        localStorage.removeItem(PORTAL_TOKEN_KEY);
    } catch {
        // Authentication state is also cleared from memory.
    }
}
